import React from 'react'
import * as Yup from 'yup'
import { Formik } from 'formik'

import Card from '@components/Card'
import Axios from '@components/Axios'
import Modal from '@components/Modal'
import Button from '@components/Button'

import FormGroup from './components/FormGroup'

const AddEdit = props => {
  let { close, item, updateList } = props

  const schema = {
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: Yup.object().shape({
      author: Yup.string().required('REQUIRED'),
      responsibility: Yup.string().required('REQUIRED'),
      position: Yup.number().required('REQUIRED'),
      text: Yup.string().max(250).required('REQUIRED')
    })
  }

  const footer = submit => {
    return <Button onClick={submit}>FEEDBACKS_ADD_CARD_SEND</Button>
  }

  const onSuccess = () => {
    close()
    updateList()
  }

  const add = ({ handleSubmit, ...formik }) => {
    return (
      <Card footer={() => footer(handleSubmit)}>
        <FormGroup {...props} formik={formik} />
      </Card>
    )
  }

  const edit = ({ handleSubmit, ...formik }) => {
    return (
      <Modal
        open={item}
        close={close}
        title="FEEDBACKS_EDIT_MODAL_TILE"
        actions={<Actions onSubmit={handleSubmit} />}
      >
        <FormGroup {...props} formik={formik} />
      </Modal>
    )
  }

  const Actions = ({ onSubmit }) => {
    return (
      <div className="actions">
        <Button color="secondary" onClick={() => close()}>FEEDBACKS_BUTTON_CLOSE</Button>
        <Button onClick={onSubmit}>FEEDBACKS_ADD_CARD_SEND</Button>
      </div>
    )
  }

  let params = {}
  if (item._id) {
    params = {
      method: 'put',
      others: item._id
    }
  } else {
    params = {
      method: 'post'
    }
  }

  const onSubmit = ({ values, submit, resetForm }) => {
    let formData = values
    submit({ formData })
    resetForm()
  }

  return (
    <div className="AddEdit">
      <Axios
        {...params}
        api="feedbacks"
        onSuccess={onSuccess}
        headers={{ 'Content-type': "application/json;boundary='cecarbon'" }}
      >
        {({ submit }) => (
          <Formik
            {...schema}
            onSubmit={(values, event) => onSubmit({ ...event, values, submit })}
          >
            {formik => (item._id ? edit(formik) : add(formik))}
          </Formik>
        )}
      </Axios>
    </div>
  )
}

export default AddEdit
